<template>
  <div v-if="product.facts.length > 0 || product.properties.length > 0" class="mt-24 grid grid-cols-2 sm:grid-cols-4 gap-x-8 gap-y-8">
    <div v-if="getStrength(product) > 0" class="rounded-md p-12 border border-grey400">
      <div class="text-xs sm:text-xs text-small-medium mb-6">
        {{ productListingResources.strength }}
      </div>
      <FiveDots
        v-if="getStrength(product)"
        :dots="getStrength(product)"
      />
    </div>
    <div v-if="factFlavor[0] && factFlavor[0].value" class="rounded-md p-12 border border-grey400">
      <div class="text-xs sm:text-xs text-small-medium mb-6">
        {{ factFlavor[0].name }}
      </div>
      <div class="text-xs truncate">
        {{ factFlavor[0].value }}
      </div>
    </div>
    <div v-if="factFormat[0] && factFormat[0].value" class="rounded-md p-12 border border-grey400">
      <div class="text-xs sm:text-xs text-small-medium mb-6">
        {{ factFormat[0].name }}
      </div>
      <div class="text-xs truncate">
        {{ factFormat[0].value }}
      </div>
    </div>
    <div
      v-if="product.properties.length && propertiesWeight[0] && propertiesWeight[0].value"
      class="rounded-md p-12 border border-grey400"
    >
      <div class="text-xs sm:text-xs text-small-medium mb-6">
        {{ propertiesWeight[0].name }}
      </div>
      <div v-if="propertiesWeight[0].value" class="text-xs">
        {{ addSpace(propertiesWeight[0].value) }}
      </div>
    </div>
  </div>
</template>
  
<script setup lang="ts">
import { type IProduct } from '~/api-types';
import { useGlobalContentStore } from '~/store/globalContent';
import FiveDots from '~/components/product/FiveDots.vue';
import useProduct from '~/composables/useProduct';
const globalContentStore = useGlobalContentStore();
const productListingResources = globalContentStore.productListingResources;
const { getStrength } = useProduct();
const props = defineProps<{
  product: IProduct;
}>();

const factFlavor = computed(() => {
  return props.product.facts.filter(i => i.code === 'FlavorKey');
});

const factFormat = computed(() => {
  return props.product.facts.filter(i => i.code === 'BrandedSizeKey');
});

const propertiesWeight = computed(() => {
  return props.product.properties.filter(i => i.code === 'CUNetWeight');
});

const addSpace = (string: string) => {
  const regex = /(\d+)([^0-9,.]+)/;
  const modifiedString = string.replace(regex, '$1 $2');
  return modifiedString;
};
  
</script>
  
